/**
 * ADR 0418 D4 — ask the API whose page this is. Network only; judging happens in brand-state.ts.
 * `credentials: "omit"`: the endpoint is public and CORS lets any origin read it only without
 * credentials (api `common/cors-origin.ts`) — sending cookies would make unknown hosts fail.
 */
import type { BrandResponse } from "./brand-state";
import { API_BASE } from "./token-store";

export async function fetchBrand(host: string, timeoutMs = 5000): Promise<BrandResponse> {
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch(`${API_BASE}/api/v1/public/brand?host=${encodeURIComponent(host)}`, {
      credentials: "omit",
      signal: ctrl.signal,
    });
    let body: unknown = null;
    try {
      body = await res.json();
    } catch {
      body = null; // not JSON = not our endpoint; brand-state treats it as "no verdict"
    }
    return { status: "http", httpStatus: res.status, body };
  } catch {
    return { status: "network-error" };
  } finally {
    clearTimeout(timer);
  }
}
